import axiosInstance from "../../../../api/axiosInstance";
import { endpoints } from "../../../../services/endpoints";
import { getSubscriptionRequest, getSubscriptionRequestError, getSubscriptionRequestSuccess } from "../../../slices/teams/members/GetSubscriptionSlice";

export const GetSubscriptionApi = () => async (dispatch) => {

    const url = `${endpoints.SubscriptionList}`;
    try {
        dispatch(getSubscriptionRequest());
        axiosInstance({
            method: "GET",
            url: url,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getSubscriptionRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getSubscriptionRequestError(_error));
            });
    } catch (error) { }
};
